module.exports = __webpack_public_path__ + "img/20190524164017074.6f84ba69.png";